import { Alert } from "react-bootstrap"
import { useSelector } from "react-redux"
import { RootState } from "../globalStore/rootreducer"
import util from "../ts/util"

const AlertComponent: React.FC<{ className?: string }> = (props) => {
  const warnList = useSelector((state: RootState) => state.alert.warns)
  const infoList = useSelector((state: RootState) => state.alert.infos)
  const errorList = useSelector((state: RootState) => state.alert.errors)

  const widthClassName = props.className != null ? props.className : `w-90rem`
  return (
    <>
      {(warnList.length > 0 || infoList.length > 0 || errorList.length > 0) && (
        <>
          {errorList.length > 0 && (
            <Alert className={widthClassName} variant={"danger"}>
              {util.stringArray.toComponent(errorList)}
            </Alert>
          )}
          {warnList.length > 0 && (
            <Alert className={widthClassName} variant={"warning"}>
              {util.stringArray.toComponent(warnList)}
            </Alert>
          )}
          {infoList.length > 0 && (
            <Alert className={widthClassName} variant={"info"}>
              {util.stringArray.toComponent(infoList)}
            </Alert>
          )}
        </>
      )}
    </>
  )
}

export default AlertComponent
